import {DatePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {Box, FormControl, FormHelperText, FormLabel, TextField} from "@mui/material";
import React from "react"
import StatusComponent from "./StatusComponent";
import {preventDefaultOnDropFiles} from "../helpers/stubFunctions";
import {CommonProps} from "./types/types";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import {withSharedMemo} from "./memo/memoComponent";
import DisplayTextComponent from "./DisplayTextComponent";

interface DateComponentProps extends CommonProps {
    onChange: (event: Date | string | null) => void;
    onFocus?: ((event: React.FocusEvent<any>) => void) | null;
}

const DateComponent = (
        {
            required,
            editable,
            displayText,
            value,
            onChange,
            errorText = "",
            onFocus = null,
            status = StatusUpdateAnswer.NONE, id,
            hint
        }: DateComponentProps) => {
    const hasError = !!errorText;
    const anchorRef = React.useRef<HTMLDivElement>(null);
    return (
            <FormControl disabled={!editable} required={required} error={hasError} sx={{width: "100%", position: "relative"}}>
                <Box display="flex" alignItems="center" gap={1}>
                    <FormLabel disabled={!editable} error={hasError} required={false}
                               htmlFor={id}>
                        <DisplayTextComponent text={displayText} required={required} hint={hint}/>
                    </FormLabel>
                    <StatusComponent status={status}/>
                </Box>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                            value={value === "" ? null : value}
                            onChange={onChange}
                            renderInput={(params) => <TextField
                                    {...params}
                                    id={id}
                                    fullWidth
                                    ref={anchorRef}
                                    error={hasError}
                                    onFocus={e => onFocus && onFocus(e)}
                                    onPaste={e => {
                                        //@ts-ignore
                                        let copyValue = (e.clipboardData || window.clipboardData).getData('text');
                                        if (isNaN(Date.parse(copyValue))) e.preventDefault();
                                    }}
                                    onDrop={(e) => {
                                        preventDefaultOnDropFiles(e);
                                        let value = e.dataTransfer.getData("text");
                                        if (isNaN(Date.parse(value))) e.preventDefault();
                                    }}
                            />
                            }
                            disabled={!editable}

                    />
                </LocalizationProvider>
                {hasError && <FormHelperText error>{errorText}</FormHelperText>}
            </FormControl>
    )
}

export default withSharedMemo(DateComponent);